import { useIntl } from 'react-intl'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'

interface Props {
  value?: 'total' | 'perPerson'
  onChange?: (value: 'total' | 'perPerson') => void
}

function HotelPriceToggle({ value = 'total', onChange }: Props) {
  const intl = useIntl()

  const totalPriceLabel = intl.formatMessage({
    id: 'kGgDSvtOWXZi9MJV-MQC',
    defaultMessage: 'Total price',
    description: 'Toggle label for showing total price in hotel price toggle',
  })

  const perPersonLabel = intl.formatMessage({
    id: 'nrkVKqo7sbL3FTKdBcdQ',
    defaultMessage: 'Per person',
    description: 'Toggle label for showing per person price in hotel price toggle',
  })

  return (
    <form>
      <SegmentedOptionsGroup
        inputsName="hotelPriceMode"
        onValueChange={onChange}
      >
        <SegmentedOption
          checked={value === 'total'}
          value="total"
          title={totalPriceLabel}
        />
        <SegmentedOption
          checked={value === 'perPerson'}
          value="perPerson"
          title={perPersonLabel}
        />
      </SegmentedOptionsGroup>
    </form>
  )
}

export default HotelPriceToggle
